<template>
  <div>
    <p>Lost in Space is a webcomic posted every weekday (before midnight). Readers then have until 7:30 pm Eastern to submit suggestions for what the protagonist should do next!</p>

    <p>You can either submit a suggestion, or vote for one already submitted.</p>

    <p>Check out:</p>

    <ul>
      <li><a href="http://erty.me">The Author's Website</a></li>
      <li><a href="/thelibrary">An earlier incarnation of this idea</a></li>
    </ul>

    <hr>

    <p>This site is in beta, and these terms may be updated without prior notice.</p>

    <p>All comic content and site design &copy; Erty Seidohl 2014-2017.</p>

    <p>Suggestions, comments, and other user-generated data belong to their respective authors.</p>

    <p>If you are disrespectful, post obscene comments, or links to external sites, your user account may be banned and your comments removed.</p>

    <p>Erty is the final arbiter of what happens in the comics. While he'll try to be fair, if something is completely off the rails, he reserves the right to fudge the votes, like any good DM would do.</p>

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// About.vue?36955fdc